import YoutubeSVG from 'assets/icons/social/youtube.svg';
import XSVG from 'assets/icons/social/x.svg';
import InstagramSVG from 'assets/icons/social/instagram.svg';
import PintrestSVG from 'assets/icons/social/pintrest.svg';
import FacebookSVG from 'assets/icons/social/facebook.svg';
import styles from './global-footer.module.scss';

export const socialLinks = [
	{
		title: 'external: facebook.com/metmuseum',
		url: 'https://www.facebook.com/metmuseum',
		icon: <FacebookSVG className={styles.socialItemIcon} />,
		siteName: 'Facebook',
	},
	{
		title: 'external: twitter.com/metmuseum',
		url: 'https://x.com/metmuseum',
		icon: <XSVG className={styles.socialItemIcon} />,
		siteName: 'X',
	},
	{
		title: 'external: pinterest.com/metmuseum/',
		url: 'https://pinterest.com/metmuseum/',
		icon: <PintrestSVG className={styles.socialItemIcon} />,
		siteName: 'Pinterest',
	},
	{
		title: 'external: instagram.com/metmuseum',
		url: 'https://www.instagram.com/metmuseum/',
		icon: <InstagramSVG className={styles.socialItemIcon} />,
		siteName: 'Instagram',
	},
	{
		title: 'external: youtube.com/user/metmuseum',
		url: 'https://www.youtube.com/user/metmuseum',
		icon: (
			<YoutubeSVG
				className={`${styles.iconYoutube} ${styles.socialItemIcon}`}
			/>
		),
		siteName: 'YouTube',
	},
];
